"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.StyledLabel = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const typography_1 = require("../styles/typography");
const standaloneStyles = styled_components_1.css `
  ${typography_1.defaultText}
  margin-bottom: 0;
`;
exports.StyledLabel = styled_components_1.default.label `
  ${typography_1.smallText}
  color: ${(props) => props.error ? props.theme.colors.error : props.theme.colors.textDefault};
  display: inline-block;
  margin-bottom: ${(props) => props.theme.spacing.xs};

  ${(props) => props.variant === 'standalone' && standaloneStyles};
`;
/**
 * Designed to be used as the label for input fields.
 */
const Label = (_a) => {
    var { children, htmlFor, variant = 'default', error = false } = _a, commonProps = __rest(_a, ["children", "htmlFor", "variant", "error"]);
    return (react_1.default.createElement(exports.StyledLabel, Object.assign({}, commonProps, { htmlFor: htmlFor, variant: variant, error: error }), children));
};
exports.Label = Label;
exports.default = exports.Label;
